import { isValid } from 'date-fns';
import { formatDateReturningDateObject } from '../../../../../utils/dates';
import { OptionValue } from '../../../../Crud/filters/components/MultiOptionsSelectorFilter/components/MultiOptionsSelector/components/OptionsList/optionsList.types';
import { FilterProps, PossibleFilters } from '../../../../Crud/filters/sharedBetweenFilters/types';
import { FilterOptions } from '../../../filter.types';
import { DateShortcut } from '../../DateRangeFilterV2/dateRangeFilter.types';

export const getValueAndOnChange = (option: FilterProps): FilterOptions<any> => {
  switch (option.type) {
    case PossibleFilters.OPTIONS_SELECTOR_WITH_DYNAMIC_DATA:
      return {
        onChange: option.multiDynamicOptionsArgs.setSelectedOptions,
        value: option.multiDynamicOptionsArgs.selectedOptions,
      };

    case PossibleFilters.OPTIONS_SELECTOR_CREATOR:
      return {
        onChange: () => {
          return undefined;
        },
        value: undefined,
      };

    case PossibleFilters.OPTIONS_SELECTOR_WITH_STATIC_DATA:
      return {
        onChange: (value) =>
          option.multiStaticOptionsArgs.setSelectedOptions(value as OptionValue[]),
        value: option.multiStaticOptionsArgs.selectedOptions,
      };

    case PossibleFilters.DATE_RANGE: {
      const finalDateInUserTimezone = formatDateReturningDateObject(
        option.dateRangeArgs?.finalDate,
      );
      const initialDateInUserTimezone = formatDateReturningDateObject(
        option.dateRangeArgs?.initialDate,
      );

      return {
        onChange: (value) => {
          if (!isValid(value.initialDate) && !isValid(value.finalDate)) {
            option.dateRangeArgs.setInitialDate(null);
            option.dateRangeArgs.setFinalDate(null);
            option.dateRangeArgs.setShortcut(DateShortcut.ALL_PERIOD);
            option.dateRangeArgs.setShortcutStep(value.shortcutStep);
            return;
          }

          option.dateRangeArgs.setInitialDate(value.initialDate);
          option.dateRangeArgs.setFinalDate(value.finalDate);
          option.dateRangeArgs.setShortcut(value.shortcut);
          option.dateRangeArgs.setShortcutStep(value.shortcutStep);
        },
        value: {
          initialDate: initialDateInUserTimezone,
          finalDate: finalDateInUserTimezone,
          shortcut: option.dateRangeArgs.shortcut,
          shortcutStep: option.dateRangeArgs.shortcutStep,
        },
      };
    }

    case PossibleFilters.NUMBER_RANGE:
    case PossibleFilters.NUMBER_RANGE_V2:
      return {
        onChange: (value) => {
          option.numberRangeArgs.setMinValue(value.minValue);
          option.numberRangeArgs.setMaxValue(value.maxValue);
        },
        value: {
          minValue: option.numberRangeArgs.minValue,
          maxValue: option.numberRangeArgs.maxValue,
        },
      };

    case PossibleFilters.SEARCH_BAR:
      return {
        onChange: option.textArgs.setValue,
        value: option.textArgs.value,
      };

    case PossibleFilters.RADIO:
      return {
        onChange: option.radioArgs.selectValue,
        value: option.radioArgs.selectedValue,
      };

    default:
      throw new Error('invalid type');
  }
};
